import React from "react";
import { motion } from "framer-motion";

const BLUE_GRADIENT = "linear-gradient(12.01deg, #1A56DB 25%, #2563EB 75%)";

const BikeCard = ({ car, onBook }) => {
  const price = car.costToCustomer != null ? Number(car.costToCustomer) : null;

  return (
    <motion.article
      layout
      className={`relative bg-[#FEFEFE] border border-[#F0F0F8] rounded-[10.5px] overflow-hidden transition-all ${car.isSoldOut ? "opacity-60" : ""}`}
      style={{ minHeight: 240 }}
    >
      {/* Bike image — right side, absolutely positioned */}
      <div className="absolute right-5 top-3" style={{ width: 225, aspectRatio: "1312/1199" }}>
        <img
          src={car.imageUrl || "/assets/sample.png"}
          alt={car.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Left: details */}
      <div className="absolute left-5 top-3 flex flex-col gap-4 items-start">
        {/* Name + model year */}
        <div className="flex flex-col gap-[5.3px] items-start">
          <span className="text-[#403737] text-[24px] font-semibold font-['Outfit'] leading-[100%] tracking-[0.24px] whitespace-nowrap">
            {car.name}
          </span>
          {car.modelYear && (
            <span className="text-[#8C8C8C] text-[16px] font-medium font-['Outfit'] tracking-[0.32px]">
              {car.modelYear} Model
            </span>
          )}
        </div>

        {/* Specs — inline with separator bars */}
        <div className="flex items-center gap-[10.5px] h-[26.4px]">
          <span className="text-[#2D2D37] text-[16px] font-medium font-['Outfit'] tracking-[0.32px] whitespace-nowrap">
            {car.seater} Seats
          </span>
          <div className="w-[1.3px] h-5 bg-[#2D2D37]" />
          <span className="text-[#2D2D37] text-[16px] font-medium font-['Outfit'] tracking-[0.32px] whitespace-nowrap">
            {car.transmissionTypeText}
          </span>
          <div className="w-[1.3px] h-5 bg-[#2D2D37]" />
          <span className="text-[#2D2D37] text-[16px] font-medium font-['Outfit'] tracking-[0.32px] whitespace-nowrap">
            {car.fuelTypeText}
          </span>
        </div>

        {/* Pricing section */}
        <div className="flex flex-col gap-[5.3px] items-start">
          {/* Inclusion banner */}
          <div className="bg-[#EFF6FF] rounded-[5.3px] px-[10.5px] py-[5.3px] flex gap-4 items-start">
            {/* Helmet */}
            <div className="flex flex-col gap-[5.3px] items-start">
              <div className="flex items-center gap-[5.3px]">
                <img src="/assets/icons/helmet-icon.svg" alt="Helmet" width={16} height={16} />
                <span className="text-[#2D2D37] text-[14px] font-medium font-['Outfit'] tracking-[0.28px] whitespace-nowrap">
                  Helmet
                </span>
              </div>
              <span className="text-[#505050] text-[12px] font-normal font-['Outfit'] tracking-[0.24px] whitespace-nowrap">
                1 Included
              </span>
            </div>
            {/* Zero Security Deposit */}
            <div className="flex items-start gap-[5.3px]">
              <img src="/assets/icons/shield-check.svg" alt="Shield" width={16} height={16} className="mt-0.5" />
              <span className="text-[#2D2D37] text-[14px] font-medium font-['Outfit'] tracking-[0.42px] w-[91px]">
                Zero Security Deposit
              </span>
            </div>
          </div>

          {/* Price */}
          <div className="flex items-end gap-[5.3px]">
            <span className="text-[#CD2525] text-[24px] font-bold font-['Outfit'] tracking-[-0.24px]">
              {price != null ? `₹${price.toLocaleString("en-IN")}` : "—"}
            </span>
            <span className="text-[#2D2D37] text-[16px] font-normal font-['Outfit'] tracking-[0.32px] mb-0.5">
              /Day
            </span>
          </div>

          {/* Free km per day */}
          {car.totalFreeKms > 0 && (
            <span className="text-[#7F7F7F] text-[14px] font-medium font-['Outfit'] tracking-[-0.14px]">
              Free {car.totalFreeKms} KM per day
            </span>
          )}
        </div>
      </div>

      {/* Book Now — bottom right, absolutely positioned */}
      <button
        disabled={car.isSoldOut}
        onClick={() => onBook(car)}
        className={`absolute bottom-5 right-5 h-[39.6px] w-[186px] rounded-[10.5px] text-[18px] font-medium font-['Outfit'] tracking-[0.53px] text-white whitespace-nowrap ${car.isSoldOut ? "bg-gray-200 text-gray-400" : "border border-[#6595FF] shadow-[0px_13.2px_15.8px_rgba(26,86,219,0.2)]"}`}
        style={!car.isSoldOut ? { backgroundImage: BLUE_GRADIENT } : undefined}
      >
        {car.isSoldOut ? "Sold Out" : "Book Now"}
      </button>
    </motion.article>
  );
};

export default BikeCard;
